import * as React from 'react'
import {AssociatedFeature} from "../domain/AssociatedFeature";
import {Definition} from "../domain/Definition";
import classNames from 'classnames';
import {DisAssociate, ReAssociate} from "../../../actions/actions";
import {DisplayFeature} from "../../contract-features-3/domain";

interface AssociationElementProps {
    key: string
    association: AssociatedFeature,
    selectHandler: (association: AssociatedFeature) => void,
    selectedFeature: DisplayFeature,
    selectedAssociation: AssociatedFeature,
    disAssociateHandler: DisAssociate,
    reAssociateHandler: ReAssociate,
    attributePopoverData: Definition[],
    disableDescriptiveName: boolean,
}


export default class AssociationElement extends React.Component<AssociationElementProps, {open: Boolean}> {

    constructor(props: AssociationElementProps){
        super(props);
        this.state = {
            open: false
        }
    }

    toggleOpen(e: React.MouseEvent){
        e.stopPropagation();
        this.setState({open: !this.state.open})
    }

    selectAssociation(){
        this.props.selectHandler(this.props.association);
    }

    handleDisAssociateClick(associationId: string, event: React.MouseEvent){
        event.preventDefault();
        event.stopPropagation();
        this.props.disAssociateHandler(associationId);
    }

    handleReAssociateClick(associationId: string, event: React.MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.props.reAssociateHandler(associationId)
    }


    render(){

        const {association, selectHandler, selectedFeature, selectedAssociation, disAssociateHandler, reAssociateHandler,
            attributePopoverData, disableDescriptiveName} = this.props;
        const numOfChildren = association.childFeatures.length;

        const childListClasses = classNames({
            childList: true,
            open: this.state.open
        });

        const isGhost = association.origin == "NVDB" && numOfChildren == 0; // Ghost = not imported from NVDB and has no children in project.

        const associationContainerClasses = classNames({
            associationContainer: true,
            selected: selectedAssociation && selectedAssociation.id === association.id,
            ghost: isGhost,
            deletedAssociation: association.operation === "DELETE"
        });

        let isExporting = !!this.props.association && this.props.association.isExporting;

        let assocName = association.name.split("#")[0];
        const expanderText = numOfChildren + ( numOfChildren === 1? " koblet objekt" : " koblede objekter" );

        return (

            <div className="tree-element"><div className="tree-hook"></div>
                <div key={association.id} className="AssociationElement">

                    <div className={associationContainerClasses}>
                        <div className="info" onClick={() => this.selectAssociation()} >
                            {disableDescriptiveName
                                ? <div className="associationName" title={association.name}>
                                    { association.origin === "NVDB" &&
                                    <div className="origin-badge">NVDB</div>
                                    }
                                    {association.featureType}, {association.name}


                                </div>
                                : <div className="associationName" title={association.name}>
                                    { association.origin === "NVDB" &&
                                    <div className="origin-badge">NVDB</div>
                                    }
                                    {association.descriptiveName}


                                </div>
                            }
                            {numOfChildren > 0 &&
                                <span onClick={(e) => this.toggleOpen(e)} className="expander text-mid-gray">{expanderText}</span>
                            }
                        </div>

                        <div className="associationElementTools">

                            { !isExporting && association.associationId && (association.operation === "READ" || association.operation === "WRITE") &&
                                <button className="disassociate-button glyphicon glyphicon-scissors associationElementIcon"
                                        title="Fjern sammenkobling"
                                        onClick={(e) => this.handleDisAssociateClick(association.associationId, e)}
                                />
                            }

                            { !isExporting && association.associationId && association.operation === "DELETE" &&
                                <button className="disassociate-button glyphicon glyphicon-link associationElementIcon"
                                        title="Gjenopprett sammenkobling"
                                        onClick={(e) => this.handleReAssociateClick(association.associationId, e)}
                                />
                            }

                        </div>
                    </div>

                    <div className={childListClasses}>
                        {association.childFeatures.map((child) => {
                            return (
                                <AssociationElement
                                    association={child}
                                    key={child.id}
                                    selectHandler={selectHandler}
                                    selectedFeature={selectedFeature}
                                    selectedAssociation={selectedAssociation}
                                    disAssociateHandler={disAssociateHandler}
                                    reAssociateHandler={reAssociateHandler}
                                    attributePopoverData={attributePopoverData}
                                    disableDescriptiveName={disableDescriptiveName}
                                />
                            )}
                        )
                        }
                    </div>

                </div>
            </div>
        )
    }


}


